module.exports = __webpack_public_path__ + "static/media/icon-home.c967c283.svg";